import React from "react"
import {FieldManagementPreviewProps} from "../../../../render/management-preview";
import FakeAttachmentViewNoPreviewSmall
    from "../../../../../gd-components/files/attachment-view/no-preview/fake-no-preview-small";


export default function FieldAttachment_ManagementPreview(props: FieldManagementPreviewProps) {

    return (
        <FakeAttachmentViewNoPreviewSmall />
    )
}
